import React from "react";
import { createRoot } from "react-dom/client";

/**
 * Boot from env.json (the file the Vault export writes on the servers), with
 * env.js as the dev-time fallback. The app module is imported lazily so that
 * window._APP_CONFIG is populated before any module-level read runs — and an
 * empty env.json (the Docker missing-bind-mount failure mode) falls through
 * to env.js instead of shipping a blank page.
 */
const render = () => {
  void import("./app").then(({ App }) => {
    const container = document.getElementById("root");
    if (!container) return;
    createRoot(container).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });
};

const hasConfig = (config: unknown): boolean =>
  Boolean(
    config &&
      typeof config === "object" &&
      (config as { api?: { endpoint?: string } }).api?.endpoint
  );

if (hasConfig(window._APP_CONFIG)) {
  render();
} else {
  fetch(`${window.location.origin}/env.json`)
    .then((r) => r.json())
    .then((json) => {
      if (hasConfig(json)) {
        window._APP_CONFIG = json;
      }
    })
    .catch(() => undefined)
    .finally(() => {
      if (!hasConfig(window._APP_CONFIG)) {
        const script = document.createElement("script");
        script.src = "/env.js";
        script.onload = render;
        script.onerror = render;
        document.head.appendChild(script);
        return;
      }
      render();
    });
}
